import { FC, memo } from 'react';

import InstructorTemplate from '../../components/instructur-template/InstructorTemplate';
import { InstructorTemplateProps } from '../../components/instructur-template/type';
import Route from '../../components/route/Route';
import { RoutePath } from '../../components/route/type';

const DATA: InstructorTemplateProps = {
  cv: [
    'geboren 1974 in Lyon (Frankreich)',
    '1995 - 2010 Vovinam Viet-Vo-Dao, 2. Dan (André Trancoso, Daniel Bloume)',
    '2006 - 2010 Ausbilder für Vovinam Viet-Vo-Dao',
  ],
  name: 'Emmanuel Brun',
  school: {
    name: 'Systema Lyon, Frankreich',
  },
  systema: [
    <>Systema Ryabko & Systema Vasiliev (Stéphane Vartanian)</>,
    <>Systema Vasiliev & Systema Talanov (Julien Micollet)</>,
    <>Systema Ryabko (Alexander Andreychenkov)</>,
    <>
      2010 - 2014 <Route href={RoutePath.SystemaRyabko}>Systema Ryabko</Route> (
      <Route href={RoutePath.FalkoZander}>Falko Zander</Route>)
    </>,
    <>
      seit 2014 <Route href={RoutePath.SolovevStyle}>Solovev Defense</Route> (Falko Zander)
    </>,
    <>
      seit 2018 <Route href={RoutePath.KampkunstPu}>Privatschüler</Route> von Falko Zander
    </>,
    <>Gründer, Systema Lyon, Frankreich</>,
    <>
      <Route href={RoutePath.KampfkunstInstructorProgram}>Instructor</Route>, Solovev Defense
    </>,
    <>
      <Route href={RoutePath.KampfkunstRanking}>7. Schülergrad</Route>, Solovev Defense
    </>,
  ],
};

const EmmanuelBrun: FC = () => <InstructorTemplate {...DATA} />;
export default memo(EmmanuelBrun);
